export default {
  login: {
    title: 'Admin Portal',
    button: 'Đăng nhập',
    message: {
      success: 'Đăng nhập thành công',
      invalid_email: 'Email không hợp lệ',
      invalid_password: 'Mật khẩu không hợp lệ'
    },
    email: 'Email',
    password: 'Mật khẩu'
  },
  sidebar: {
    admin: {
      title: 'Admin',
      dashboard: 'Bảng điều khiển'
    }
  },
  route: {
    dashboard: 'Bảng điều khiển',
    not_found: 'Không tìm thấy trang',
    login: 'Đăng nhập'
  },
  dashboard: {
    title: 'Bảng điều khiển'
  },
  page_404: {
    error_404: 'Không tìm thấy trang',
    back_to_home: 'Quay về trang chủ'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js